export default "__VITE_ASSET__D5hCWeJq__"